import React from 'react';
import { ListenerHandle } from '@projectstorm/react-canvas-core';
import * as _ from 'lodash';
import { MetricsPortModel } from './MetricsPortModel';
import { MetricsPortLabel } from "./MetricsPortLabel";
import UnfoldMoreSharpIcon from '@mui/icons-material/UnfoldMoreSharp';
import UnfoldLessSharpIcon from '@mui/icons-material/UnfoldLessSharp';
import { MetricsNodeProps } from './metrics-factory';
import { S } from './MetricsNodeFactory';
/**
 * Default node that models the DefaultNodeModel. It creates two columns
 * for both all the input ports on the left, and the output ports on the right.
 */

export class MetricNodeWidget extends React.Component<MetricsNodeProps> {
    ob: any;
    ref: React.RefObject<HTMLDivElement>;
    listener: ListenerHandle | null;
    constructor(props: MetricsNodeProps) {
        super(props);
        this.listener = null;
        this.ref = React.createRef();
    }
    componentDidMount(): void {
        // @ts-ignore
        this.ob = new ResizeObserver((entities) => {
            const bounds = entities[0].contentRect;
        });
        if (this.ref && this.ref.current) {
            const b = this.ref.current.getBoundingClientRect();
            this.ob.observe(this.ref.current);
        }
        this.installSelectionListener();
    }
    componentDidUpdate(prevProps: Readonly<MetricsNodeProps>, prevState: Readonly<any>, snapshot?: any): void {
        if (this.listener && this.props.node !== prevProps.node) {
            this.listener.deregister();
            this.installSelectionListener();
        }
    }


    componentWillUnmount(): void {
        this.ob.disconnect();
        this.ob = null;

        this.listener?.deregister();
        this.listener = null;
    }

    generatePort = (port: MetricsPortModel) => {
        if (this.props.node.properties?.collapsed && Object.keys(port.links).length === 0) {
            return <MetricsPortLabel collapsed engine={this.props.engine} port={port} key={port.getID()} />;
        }
        return <MetricsPortLabel engine={this.props.engine} port={port} key={port.getID()} />;
    }

    installSelectionListener() {
        this.listener = this.props.node.registerListener({
            selectionChanged: (event: any) => {
                this.props.node.selectionChanged();
            }
        });
    }


    render() {
        return (
            <S.Node
                ref={this.ref}
                data-default-node-name={this.props.node.getName()}
                selected={this.props.node.isSelected()}
                background={this.props.node.getColor()}>
                <S.Title>
                    <S.TitleName>{this.props.node.getName()}</S.TitleName>
                    <div style={{ position: 'absolute', right: -20, top: -10, cursor: 'pointer' }}>{this.props.node.properties?.collapsed ?
                        <UnfoldMoreSharpIcon onClick={() => {
                            if (this.props.node.properties) {
                                this.props.node.properties.collapsed = false;
                            }
                        }} /> :
                        <UnfoldLessSharpIcon onClick={() => {
                            if (this.props.node.properties) {
                                this.props.node.properties.collapsed = true;
                            }
                        }} />}</div>
                </S.Title>
                <S.Ports>
                    <S.PortsContainer>{_.map(this.props.node.getInPorts(), this.generatePort)}</S.PortsContainer>
                    <S.PortsContainer>{_.map(this.props.node.getOutPorts(), this.generatePort)}</S.PortsContainer>
                </S.Ports>
            </S.Node>
        );
    }
}
